export default __webpack_public_path__ + "static/media/DO.d3a7dd98.svg";